import React, { useEffect, useState } from 'react';
import { Modal, Row, Col, Button, Input, Checkbox, Spin } from 'antd';
import {
  EditOutlined,
  CheckCircleOutlined,
  // CheckCircleOutlined,
  CloseCircleOutlined,
  // QuestionCircleOutlined,
} from '@ant-design/icons';
// import CompanyLight from '../../assets/images/CompanyLight.png';
import Brand1 from '../../assets/images/Brand1.png';
// import tickIcon from '../../assets/images/tickIcon.png';
// import Subtract from '../../assets/images/Subtract.png';
import './ingredientListDialog.scss';
import Attributes from '../../redux/middleware/attributes';

type Props = {
  open: boolean;
  handleClose: any;
  data: any;
  component?: any;
  handleMarkRecipe?: any;
  loader?: boolean;
};
const IngendientListDialog = (props: Props) => {
  let { open, handleClose, data, handleMarkRecipe, loader, component } = props;

  // const [update, setUpdate] = useState(false);
  const [defaultAllergens, setDefaultAllergens] = useState<any[]>();
  const [allergens, setAllergens] = useState<any[]>(
    data?.allergens?.filter((allergen: any) => allergen?.is_exist == true)
  );
  // const [hide, setHide] = useState<any>();
  const [updateAllegens, setUpdateAllergens] = useState(false);
  // const [updateIngredients, setUpdateIngredients] = useState(false);
  const [updateNutritions, setUpdateNutritions] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [nutritions, setNutritions] = useState<any[]>([]);
  // eslint-disable-next-line no-unused-vars
  const [allergensData, setAllergensData] = useState(data?.allergens);
  const [prevNutritions, setPrevNutritions] = useState<any[]>(
    data?.nutritions?.map((nutrition: any) => ({
      name: nutrition?.nutrition,
      quantity: nutrition?.value,
      status: nutrition?.is_verified,
    }))
  );
  const [unMatched, setUnMatched] = useState(false);
  const [statuses, setStatuses] = useState<any[]>();

  const fetchStatus = async () => {
    const { data, success } = await Attributes.getStatus();
    if (success) setStatuses(data);
  };

  useEffect(() => {
    fetchStatus();
    setAllergens(
      data?.allergens?.filter((allergen: any) => allergen?.is_exist == true)
    );
    setDefaultAllergens(
      data?.allergens?.filter((allergen: any) => allergen?.is_exist == true)
    );
    setAllergensData(data?.allergens);
    setNutritions(data?.nutritions);
    setUnMatched(
      data?.ingredients?.some(
        (ingredient: any) => ingredient?.ingredient_name == null
      )
    );
  }, [data]);

  const handleCloseNutritions = (type: string) => {
    if (type == 'cancel')
      setNutritions(
        prevNutritions?.map((prevData: any) => ({
          nutrition: prevData?.name,
          value: prevData?.quantity,
          is_verified: prevData?.status,
        }))
      );
    else
      setPrevNutritions(
        nutritions?.map((nutrition: any) => ({
          name: nutrition?.nutrition,
          quantity: nutrition?.value,
          status: nutrition?.is_verified,
        }))
      );
    setUpdateNutritions(!updateNutritions);
  };

  return (
    <div className="IngendientListDialog">
      <Modal
        title={
          <div className="title font">
            {component == 'r&d_recipe'
              ? 'R&D Recipe Approval'
              : 'R&D Sub Recipe Approval'}
          </div>
        }
        centered
        open={open}
        onCancel={handleClose}
        width={608}
        footer={null}
        className="approvalRecipeDialogContainer"
      >
        <Spin spinning={loader} size="large">
          <div className="approvalModalHeaderAlign">
            <div className="col1 font">
              <img src={Brand1} width="52px" height="52px" />
              <div className="subCol1 font recipe-name-container-width">
                <span className="col1Text font">{data?.recipe_name}</span>
                <div className="subTextCol1 font">
                  {/* <img src={CompanyLight} alt="" className="companyLight" /> */}
                  <div className="email categoryNameApprovalModal">
                    {data?.category_name}
                  </div>
                </div>
              </div>
            </div>
            {unMatched ? (
              <div className="font unmatched-ingredients-danger-message">
                You cannot approve this recipe. All ingredients are not matched.
              </div>
            ) : (
              <div className="approvalUpdateButtonContainer">
                <Button
                  className="updateButtonApproval borderRejectRecipeColor"
                  onClick={() => {
                    handleMarkRecipe(
                      {
                        status:
                          statuses?.find(
                            (filterStatus: any) =>
                              filterStatus?.status_slug?.toLowerCase() ==
                              'rejected'
                          )?.id || 0,
                        recipe_type_id: data?.recipe_type_id,
                        calorie: nutritions[0]?.value,
                        carb: nutritions[1]?.value,
                        protein: nutritions[2]?.value,
                        fat: nutritions[3]?.value,
                        allergens_id: defaultAllergens
                          ?.map((allergen: any) => allergen?.id)
                          ?.toString(),
                      },
                      data?.rb_id
                    );
                  }}
                >
                  Reject
                </Button>
                <Button
                  className="updateButtonApproval borderApproveRecipeColor"
                  onClick={() => {
                    handleMarkRecipe(
                      {
                        status:
                          statuses?.find(
                            (filterStatus: any) =>
                              filterStatus?.status_slug?.toLowerCase() ==
                              'success'
                          )?.id || 0,
                        recipe_type_id: data?.recipe_type_id,
                        calorie: nutritions[0]?.value,
                        carb: nutritions[1]?.value,
                        protein: nutritions[2]?.value,
                        fat: nutritions[3]?.value,
                        // remove duplicate values from allergens array
                        allergens_id: [
                          ...new Set(
                            allergens?.map((allergen: any) => allergen?.id)
                          ),
                        ]?.toString(),
                      },
                      data?.rb_id
                    );
                  }}
                >
                  Accept
                </Button>
              </div>
            )}
          </div>

          <ul className="ingredientListMenu">
            <li>
              <div className="title titleWithIconAlign">
                <div>Ingredients List</div>{' '}
                {/* <EditOutlined
                className="ApprovalFieldsEditIcon"
                onClick={() => setUpdateIngredients(!updateIngredients)}
              /> */}
              </div>
              <ul className="content">
                <li className="content-list">
                  <Row>
                    <Col md={12} className="LimitedAccessCol ">
                      <p>R&D Recipe Ingredients</p>
                    </Col>
                    {/* <Col md={8} className="center-text-align-approval">
                    <p>Quantity</p>
                  </Col> */}

                    <Col
                      md={12}
                      className="LimitedAccessCol tableTickCrossIcons"
                    >
                      <p>Matched Ingredients</p>
                    </Col>
                  </Row>
                </li>
                {data.ingredients?.map((data: any, index: number) => (
                  <li className="content-list" key={index}>
                    <Row>
                      <Col md={12}>
                        <p>{data?.rb_ingredient_name}</p>
                      </Col>
                      <Col
                        md={12}
                        className={`tableTickCrossIcons ${'center-text-align-approval'}`}
                      >
                        <p>{data?.ingredient_name}</p>
                      </Col>
                    </Row>
                  </li>
                ))}
              </ul>
            </li>
            <li>
              <div className="title ingredientListMenu ingredientListDialogAllergenTitle titleWithIconAlign">
                <div>Nutritions List</div>
                {updateNutritions ? (
                  <div className="cancel-editted-icon-container">
                    <CloseCircleOutlined
                      className="ingredient-unmatach-select-icons ingredient-selection-cancel-icon-color"
                      onClick={() => {
                        handleCloseNutritions('cancel');
                      }}
                    />

                    <CheckCircleOutlined
                      // style={{ color: '#53fa23', cursor: 'pointer' }}
                      className="ingredient-unmatach-select-icons ingredient-selection-success-icon-color"
                      onClick={() => {
                        handleCloseNutritions('continue');
                      }}
                    />
                  </div>
                ) : (
                  <EditOutlined
                    className="ApprovalFieldsEditIcon"
                    onClick={() => {
                      // console.log({ ...defaultData, nutritions: nutritions });
                      setUpdateNutritions(!updateNutritions);
                    }}
                  />
                )}
              </div>
              <ul className="content">
                <li className="content-list">
                  <Row>
                    <Col md={12}>
                      <p>Nutritions</p>
                    </Col>

                    {/* <Col md={8} className="LimitedAccessCol tableTickCrossIcons">
                    <p>R&D Inventory</p>
                  </Col> */}
                    <Col
                      md={12}
                      className="LimitedAccessCol tableTickCrossIcons"
                    >
                      <p>Values</p>
                    </Col>
                  </Row>
                </li>
                {nutritions?.map((nutritionObj: any, index: number) => (
                  <li className="content-list" key={index}>
                    <Row>
                      <Col md={12}>
                        <p>{nutritionObj?.nutrition}</p>
                      </Col>

                      {/* <Col md={8} className="tableTickCrossIcons">
                      <p>
                        {nutritionObj?.perm_status_id == 1 ? (
                          <img src={tickIcon} alt="" />
                        ) : (
                          <img src={Subtract} alt="" />
                        )}
                      </p>
                      <p>{nutritionObj?.value_tbh}</p>
                    </Col> */}

                      <Col md={12} className="tableTickCrossIcons">
                        {/* <p>
                        {nutritionObj?.perm_status_id == 2 ? (
                          <img src={tickIcon} alt="" />
                        ) : (
                          <img src={Subtract} alt="" />
                        )}
                      </p> */}
                        {updateNutritions ? (
                          <Input
                            placeholder={`Enter ${nutritionObj?.nutrition}`}
                            onChange={(e: any) => {
                              const dataArray = nutritions;
                              dataArray[index].value = +e.target.value;
                              // console.log(dataArray);
                              setNutritions([...dataArray]);
                            }}
                            type="number"
                            value={nutritionObj?.value}
                            required
                          />
                        ) : (
                          <p>{nutritionObj?.value}</p>
                        )}
                      </Col>
                    </Row>
                  </li>
                ))}
              </ul>
            </li>
            <li>
              <div className="title ingredientListDialogAllergenTitle titleWithIconAlign">
                <div>Allergens</div>
                {updateAllegens ? (
                  <div className="cancel-editted-icon-container">
                    <CloseCircleOutlined
                      className="ingredient-unmatach-select-icons ingredient-selection-cancel-icon-color"
                      onClick={() => {
                        setAllergens(
                          allergens?.map((filteredAllergen: any) =>
                            allergensData?.find(
                              (innerData: any) =>
                                innerData?.name == filteredAllergen?.name
                            )
                          )
                        );
                        setUpdateAllergens(!updateAllegens);
                      }}
                    />

                    <CheckCircleOutlined
                      // style={{ color: '#53fa23', cursor: 'pointer' }}
                      className="ingredient-unmatach-select-icons ingredient-selection-success-icon-color"
                      onClick={() => {
                        setAllergensData(
                          allergensData?.map((allergen: any) => {
                            const checkAllergen = allergens?.find(
                              (innerData: any) =>
                                innerData?.name == allergen?.name
                            );
                            if (checkAllergen == undefined) {
                              return allergen;
                            } else {
                              return checkAllergen;
                            }
                          })
                        );
                        // setAllergensData(
                        //   [...allergens, ...allergensData].filter(
                        //     (value, index, self) =>
                        //       index ===
                        //       self.findIndex(
                        //         (t) =>
                        //           t.place === value.place && t.name === value.name
                        //       )
                        //   )
                        // );
                        setUpdateAllergens(!updateAllegens);
                      }}
                    />
                  </div>
                ) : (
                  <EditOutlined
                    className="ApprovalFieldsEditIcon"
                    onClick={() => {
                      // [...allergens, ...allergensData]     set updatedData when click on Tick Icon
                      // [...allergensData, ...allergens]     set previousData when click on Close Icon
                      // console.log(
                      //   [...allergens, ...allergensData].filter(
                      //     (value, index, self) =>
                      //       index ===
                      //       self.findIndex(
                      //         (t) =>
                      //           t.place === value.place && t.name === value.name
                      //       )
                      //   )
                      // );

                      // console.log([...allergensData, ...allergens]);
                      setUpdateAllergens(!updateAllegens);
                    }}
                  />
                )}
              </div>
              <ul className="content">
                <li className="content-list">
                  <Row>
                    <Col md={12}>
                      <p>Allergen</p>
                    </Col>

                    {/* <Col md={8} className="LimitedAccessCol tableTickCrossIcons">
                    <p>R&D Inventory</p>
                  </Col> */}
                    <Col
                      md={12}
                      className="LimitedAccessCol tableTickCrossIcons"
                    >
                      <p>Mark / UnMark</p>
                    </Col>
                  </Row>
                </li>
                {allergensData?.map((data: any, index: number) => (
                  <li className="content-list" key={index}>
                    <Row>
                      <Col md={12}>
                        <p>{data?.name}</p>
                      </Col>

                      {/* <Col md={8} className="tableTickCrossIcons">
                      <p>
                        {data?.perm_status_id == 1 ? (
                          <img src={tickIcon} alt="" />
                        ) : (
                          <img src={Subtract} alt="" />
                        )}
                      </p>
                      <p>{data?.verified == 1 ? 'Yes' : 'No'}</p>
                    </Col> */}

                      <Col md={12} className="tableTickCrossIcons">
                        {/* <p>
                        {data?.perm_status_id == 2 ? (
                          <img src={tickIcon} alt="" />
                        ) : (
                          <img src={Subtract} alt="" />
                        )}
                      </p> */}
                        {updateAllegens ? (
                          <Checkbox
                            // disabled={recordIndex == index ? false : true}
                            onChange={(e: any) => {
                              if (
                                defaultAllergens?.find(
                                  (obj: any) => obj?.name == data?.name
                                ) == undefined
                              ) {
                                if (e.target.checked) {
                                  const extractedData = allergensData?.find(
                                    (extractData: any) =>
                                      extractData?.name == data?.name
                                  );
                                  setAllergens([
                                    ...allergens,
                                    { ...extractedData, is_exist: 1 },
                                  ]);
                                } else {
                                  setAllergens(
                                    allergens?.filter(
                                      (removeObj: any) =>
                                        removeObj?.name != data?.name
                                    )
                                  );
                                }
                              }
                            }}
                            checked={
                              allergens?.find(
                                (checkData: any) =>
                                  checkData?.name == data?.name
                              )?.is_exist == 1
                            }
                          />
                        ) : (
                          <p>{data?.is_exist == 1 ? 'Yes' : 'No'}</p>
                        )}
                      </Col>
                    </Row>
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        </Spin>
      </Modal>
    </div>
  );
};

export default IngendientListDialog;
